module.exports = __webpack_public_path__ + "static/img/video2.bb0275d6.png";